<i class="icon" [uiType]="uiType" ui-icon></i>
<span class="text">{{ text }}</span>
